export default "ابتثجحخدذرزسشصضطظعغفقكلمنهوي\n▒▓▓درسمعح▓▒\n"